import React, { FC } from 'react';
import translate from '@translate';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { ExportTypeType } from 'src/types/table';
import ExportTableAction from 'src/components/ExportTableAction';
import { useCheckPermission } from '../../utils/checkPermission';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import { useNavigate } from 'react-router-dom';
import { getTabs } from '../AllOrdersContainer/functions';
import { ExportDataType } from './constants';

type TopBlockProps = {
    handleExport: (type: ExportTypeType, dataType: ExportDataType) => void;
    reloadTableData: () => void;
};

const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();
    const permissionExportExpeditionPackages = useCheckPermission('ORDER.EXPORT.EXPEDITION_PACKAGE');
    const permissionExportExpeditionPackagesProducts = useCheckPermission(
        'ORDER.EXPORT.EXPEDITION_PACKAGE_PRODUCTS'
    );

    const handleChange = (newUrl: string) => {
        navigate('/orders/' + newUrl);
    };
    return (
        <BodyTopBlock
            tabs={getTabs()}
            selectTab={'expedition_packages'}
            onChangeTab={handleChange}
            actions={[
                {
                    node: (
                        <ExportTableAction
                            title={translate('orderExpeditionPackages.action.exportFile')}
                            handleExport={(type) => props.handleExport(type, 'packages')}
                        />
                    ),
                    hidden: !permissionExportExpeditionPackages,
                },
                {
                    onClick: () => props.reloadTableData(),
                    icon: <AutorenewIcon />,
                    tooltip: translate('orderExpeditionPackages.action.synchronizeTable'),
                    variant: 'outlined',
                },
                {
                    items: [
                        {
                            node: (
                                <ExportTableAction
                                    title={translate('orderExpeditionPackages.action.exportWithProducts')}
                                    handleExport={(type) => props.handleExport(type, 'packagesProducts')}
                                    icon={<AssignmentReturnedIcon />}
                                    textWithIcon
                                />
                            ),
                            hidden: !permissionExportExpeditionPackagesProducts,
                        },
                    ],
                },
            ]}
        />
    );
};

export default TopBlock;
